import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id B44B2BB0-0BF9-42B7-BF70-ECC7FF102520
 * name view-dashboard-outline
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/view-dashboard-outline.svg
 * tags
 * - View 
 */
export const ViewDashboardOutlineIcon = createSvgIcon(<><path d="M19,5V7H15V5H19M9,5V11H5V5H9M19,13V19H15V13H19M9,17V19H5V17H9M21,3H13V9H21V3M11,3H3V13H11V3M21,11H13V21H21V11M11,15H3V21H11V15Z" /></>, 'ViewDashboardOutlineIcon');
export default ViewDashboardOutlineIcon